<template>
    <div>
        <loading
            :active.sync="loadingContent"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a @click="$router.go(-1)" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Daftar</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule">
            <div class="section inset mt-3 m-1">
                <div>
                    <h3>Daftar Akun Baru</h3>
                    <p style="line-height: 15px">
                        <small
                            >Silahkan daftar dengan nomor handphone Anda atau
                            masuk apabila sudah memiliki akun.</small
                        >
                    </p>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="label">Nama Lengkap</label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Masukkan Nama Lengkap"
                            v-model="auth_data.name"
                            style="text-transform: capitalize"
                        />
                        <i class="clear-input">
                            <ion-icon name="close-circle"></ion-icon>
                        </i>
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="label">Nomor Handphone (WhatsApp)</label>
                        <input
                            type="number"
                            class="form-control"
                            placeholder="0823xxxxxxx"
                            v-model="auth_data.phone"
                        />
                        <i class="clear-input">
                            <ion-icon name="close-circle"></ion-icon>
                        </i>
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="label">Kode Affiliate</label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="(Tidak Wajib)"
                            v-model="auth_data.referred_by"
                            @input="
                                auth_data.referred_by =
                                    $event.target.value.toUpperCase()
                            "
                        />
                        <i class="clear-input">
                            <ion-icon name="close-circle"></ion-icon>
                        </i>
                    </div>
                </div>
                <div class="form-group mb-1 mt-1" style="line-height: 15px">
                    <small
                        >Dengan menggunakan {{ VUE_ENV.VUE_APP_NAME }}. saya
                        setuju dengan
                        <router-link :to="{ name: 'tos.data' }"
                            ><b>Ketentuan Layanan</b></router-link
                        >
                        dan
                        <router-link :to="{ name: 'privacy' }"
                            ><b>Kebijakan Privasi</b></router-link
                        >
                        {{ VUE_ENV.VUE_APP_NAME }}</small
                    >
                </div>
                <div class="form-group basic">
                    <ButtonLoader
                        :loading="loading.button"
                        :styled="'btn btn-primary btn-block btn-lg'"
                        @click.native="submitValidateRegister()"
                        :disabled="disabledButtonSubmit"
                        >Daftar Sekarang</ButtonLoader
                    >
                </div>
            </div>
            <div class="section text-center">
                <router-link
                    :to="{ name: 'care-center' }"
                    style="font-weight: bold"
                >
                    Butuh Bantuan?
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
    export default {
        name: 'auth.register',
        props: ['phone'],
        data() {
            return {
                disabledButtonSubmit: true,
                loadingContent: true,
            };
        },
        created() {
            setTimeout(() => {
                this.loadingContent = false;
            }, 300);
            this.RESET_AUTH_DATA();
            if (this.isAuth) {
                this.$router.push({ name: 'home' });
            }
            this.auth_data.phone = this.phone == undefined ? '' : this.phone;
        },
        computed: {
            ...mapGetters(['isAuth']),
            ...mapState(['loading', 'toast', 'VUE_ENV']),
            ...mapState('auth', {
                auth_data: state => state.auth_data,
            }),
        },
        methods: {
            ...mapActions('auth', ['validateRegister']),
            ...mapMutations('auth', ['RESET_AUTH_DATA']),
            convertToUppercase() {
                this.auth_data.referred_by =
                    this.auth_data.referred_by.toUpperCase();
            },
            showModalCreatePin() {
                let element = this.$refs.create_pin.$el;
                // console.log(element);
                window.$(element).modal('show');
            },
            submitValidateRegister() {
                this.$store.commit('SET_LOADING', { button: true });
                this.validateRegister()
                    .then(() => {
                        // // window.fbq("track", "CompleteRegistration");
                        this.$store.commit('SET_LOADING', { button: false });
                        this.$router.push({
                            name: 'auth.register.pin',
                            params: { back_reference: 'auth.register' },
                        });
                    })
                    .catch(error => {
                        this.$store.commit('SET_LOADING', { button: false });
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: error.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                    });
            },
        },
        watch: {
            'auth_data.phone': function () {
                if (this.auth_data.phone != '' && this.auth_data.name != '') {
                    this.disabledButtonSubmit = false;
                } else {
                    this.disabledButtonSubmit = true;
                }
            },
            'auth_data.name': function () {
                if (this.auth_data.phone != '' && this.auth_data.name != '') {
                    this.disabledButtonSubmit = false;
                } else {
                    this.disabledButtonSubmit = true;
                }
            },
        },
        mounted() {
            document.body.classList.add('bg-white');
        },
        destroyed() {
            this.$store.commit('RESET_LOADING');
        },
    };
</script>
